import React, { useState } from 'react'
import { Boy, PDF, download, downloaded, file, player,  } from '../../../assets'
import { VideoModal } from '../../Generic';

const FileType = ({fileType, downloads, onClick, text }) => {
  const [isVidModalOpen, setisVidModalOpen] = useState(false);
 
  const openVidModal = () => {
    setisVidModalOpen(true);
  };
  const closeVidModal = () => {
    setisVidModalOpen(false);
  };
  return (
    <div className='flex justify-around items-center mx-[27px] mb-[34px]'>
        <div onClick={openVidModal} className='w-[100px] z-10  sm:w-[150px] flex flex-col items-center justify-center'>
          <div className={`relative ${fileType==='video'||fileType==='img' ? 'w-[75px] h-[55px] rounded sm:w-[150px] sm:h-[110px] overflow-hidden' : 'w-[40px] h-[50px] sm:w-[80px] sm:h-[100px]'}`}>
            <img className={fileType==='video'||fileType==='img' ? 'w-full' : 'h-full'} src={fileType==='pdf' ? PDF : fileType==='files' ? file : fileType==='video' ? Boy : fileType==='img' ? Boy : 'format' } alt="" />
            {
              fileType==='video' &&
              (<div className='absolute  top-[43%] left-[43%]'><img className='w-[19px] md:w-[26px]' src={player} alt="" /></div>)
            }
          </div>
            <div className='text-gray-lightGray text-[9px] sm:text-[12px]'>{fileType==='pdf' ? 'PDF' : fileType==='files' ? 'file' : fileType==='video' ? 'video' : fileType==='img' ? 'img' : 'format' }</div>
        </div>
        <div className='min-w-[200px] font-sans font-normal text-[18px] flex justify-start' >{text}</div>
        <div>
            {
              downloads ?
              <img src={downloaded} alt="" /> :
            <img src={download} alt="" /> 
            }
        </div>
        <VideoModal children={fileType} fileType={fileType}  onClose={closeVidModal} isOpen={isVidModalOpen}/>
    </div>  
  )
}

export default FileType